<template>
  <div>
    <!-- 大咖的信息 -->
    <teacher :data="detail.teacher" class="border-bottom" v-if="isDaka"></teacher>
    <div class="con">
      <!--<div class="title">讲师介绍</div>-->
      <h4>课程详情</h4>
      <div v-html="con" id="sys-html"></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Teacher from 'components/base/ui/teacher'
export default {
  components: {
    Teacher
  },
  props: ['con', 'detail'],
  activated() {
    this.$emit('refreshScroll')
    this.$emit('setNavTitle', '课程介绍')
  },
  computed: {
    isDaka() {
      // 不是大咖就不显示
      // 不是大咖的时候就是空数组,后台接口就是这样的
      return !(!this.detail.teacher || this.detail.teacher.length === 0)
    }
  }
}
</script>
<style lang="stylus" ref="stylesheet/stylus">
#sys-html
  word-wrap break-word
  word-break break-all
</style>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .con
    padding size(30) size(30) size(98)
    font-size size(30)
    color #666
    line-height 1.6
  .title
    font-size size(34)
    color #333
    margin size(30) 0
    font-weight 700
  h4
    line-height size(60)
    font-size size(34)
    color #333
    margin-bottom size(20)
</style>



// WEBPACK FOOTER //
// src/components/systematic/systematic-intro.vue